let accessToken;
let socketId;

export function setAccessToken(token) {
  accessToken = token;
}

export function setSocketId(sid) {
  socketId = sid;
}

const setTokens = next => async req => {
  if (accessToken) {
    req.headers.set("Authorization", `Bearer ${accessToken}`);
  }

  if (socketId) {
    req.headers.set("X-Socket-ID", socketId);
  }

  const res = await next(req);

  if (res.access_token) {
    accessToken = res.access_token;
  }

  return res;
};

export default setTokens;
